export enum AirportType {
  SMALL_AIRPORT = "small_airport",
  MEDIUM_AIRPORT = "medium_airport",
  LARGE_AIRPORT = "large_airport",
  CLOSED = "closed",
  HELIPORT = "heliport",
}

